<template>
    <section class="padding-vertical-content lightgray-content mb-3 mb-lg-4" id="paso-1">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="mb-4 h3 text-uppercase">
                        Datos hijo/a o jugador
                    </div>
                    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                        <div class="padding-content white-content mb-2">
                            <b-card v-if="error === 'no'" bg-variant="success" title="Éxito" class="mb-4">
                                <b-card-text>
                                    El registro se ha completado con éxito.
                                </b-card-text>
                            </b-card>
                            <b-card v-if="error === 'si'" bg-variant="danger" title="Fallo">
                                <b-card-text>
                                    El registro no ha podido completarse.
                                </b-card-text>
                            </b-card>
                            <div class="row">
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="nombre">{{$t("formularios.nombre") + " *"}}</label>
                                        <ValidationProvider name="nombre" rules="required" v-slot="{ errors }">
                                            <input id="nombre" type="text" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " :placeholder="$t('formularios.nombre')" v-model="base.nombre" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="apellidos">{{$t("formularios.apellidos") + " *"}}</label>
                                        <ValidationProvider name="apellidos" rules="required" v-slot="{ errors }">
                                            <input id="apellidos" type="text" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " :placeholder="$t('formularios.apellidos')" v-model="base.apellidos" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="dni">{{ $t("formularios.dni") + " *" }}</label>
                                        <ValidationProvider name="dni" rules="required" v-slot="{ errors }">
                                            <input id="dni" type="text" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " :placeholder="$t('formularios.dni')" v-model="base.dni" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="fecha_nacimiento">{{$t("formularios.nacimiento") + " *"}}</label>
                                        <ValidationProvider name="fecha_nacimiento" rules="required"
                                            v-slot="{ errors }">
                                            <input id="fecha_nacimiento" type="date" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " :placeholder="$t('formularios.nacimiento')" v-model="base.fecha_de_nacimiento" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="fecha_caducidad_dni">Fecha de caducidad del DNI *</label>
                                        <ValidationProvider name="fecha_caducidad_dni" rules="required"
                                            v-slot="{ errors }">
                                            <input id="fecha_caducidad_dni" type="date" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " v-model="base.fecha_de_caducidad_dni" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="telefono">{{$t("formularios.telefono") + " *"}}</label>
                                        <ValidationProvider name="telefono" rules="required" v-slot="{ errors }">
                                            <input id="telefono" type="tel" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " :placeholder="$t('formularios.telefono')" v-model="base.telefono" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="email">{{$t("formularios.email") + " *"}}</label>
                                        <ValidationProvider name="email" rules="required" v-slot="{ errors }">
                                            <input id="email" type="email" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " :placeholder="$t('formularios.email')" v-model="base.email" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <Paises id="pais_de_nacimiento" :errors="errors" v-on:selected="
                                            (opt) => {
                                                pais = opt;
                                                base.pais_de_nacimiento = opt.nombre;
                                            }
                                        " />
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <Provincias id="provincia_de_nacimiento" :errors="errors" :pais="pais.id"
                                            v-on:selected="
                                                (opt) => {
                                                    provincia = opt;
                                                    base.provincia_de_nacimiento = opt.nombre;
                                                }
                                            " />
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <Locations id="localidad_de_nacimiento" :provincia="provincia" :errors="errors"
                                            v-on:selected="
                                                (opt) => {
                                                    base.localidad_de_nacimiento = opt.nombre;
                                                }
                                            " />
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="nacionalidad">{{$t("formularios.nacionalidad") + " *"}}</label>
                                        <ValidationProvider name="nacionalidad" rules="required" v-slot="{ errors }">
                                            <input id="nacionalidad" type="text" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " :placeholder="$t('formularios.nacionalidad')" v-model="base.nacionalidad" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="direccion">{{$t("formularios.domicilio") + " *"}}</label>
                                        <ValidationProvider name="direccion" rules="required" v-slot="{ errors }">
                                            <input id="direccion" type="text" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " :placeholder="$t('formularios.domicilio')" v-model="base.direccion" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="club_de_procedencia">Club de procedencia (si aplica)</label>
                                        <ValidationProvider name="club_de_procedencia">
                                            <input id="club_de_procedencia" type="text" class="form-control"
                                                placeholder="Club de procedencia" v-model="base.club_de_procedencia" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label>Cuota *</label>
                                        <ValidationProvider name="categoria_base" rules="required" v-slot="{ errors }">
                                            <multiselect 
                                                v-model="base.categoria_base"
                                                :class="errors[0] ? 'is-invalid' : ''" 
                                                placeholder="Categoría Base"
                                                label="name"
                                                track-by="id" 
                                                :multiple="false" 
                                                :options="categorias_bases"
                                                v-on:select="
                                                    (selectedOpt) => $emit('selected', selectedOpt)
                                                ">
                                                    <template slot="option" slot-scope="props">
                                                        <div class="option__desc"><span class="option__title">{{ props.option.name }}</span> - <span class="option__small">{{ props.option.precio | formatear_precio }}</span></div>
                                                    </template>
                                                </multiselect>
                                            <span v-if="errors[0]" class="error invalid-feedback"
                                                style="display: block">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="iban">IBAN *</label>
                                        <ValidationProvider name="iban" rules="required" v-slot="{ errors }">
                                            <input id="iban" type="text" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " placeholder="IBAN" v-model="base.iban" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                        <label for="iban">Titular de la cuenta *</label>
                                        <ValidationProvider name="titular_cuenta" rules="required" v-slot="{ errors }">
                                            <input id="titular_cuenta" type="text" :class="
                                                'form-control ' + (errors[0] ? 'is-invalid' : '')
                                            " placeholder="Titular de la cuenta *" v-model="base.titular_cuenta" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <button type="submit" name="button" class="button effect-button large-button">
                                <span>CONTINUAR</span>
                            </button>
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </section>    
</template>

<script>
import Provincias from "../../common/forms/Provincias.vue";
import Locations from "../../common/forms/Locations.vue";
import Paises from "../../common/forms/Paises.vue";

export default {
    props: ["base"],
    data() {
        return {
            errors: [],
            error: this.$route.query.error,
            categorias_bases_dropdown: [],
            provincia: null,
            pais: { id: 0 },
            nacionalidad: "Española",
            selected: null,
            items: null,
            categorias_bases: [],
        };
    },
    created() {
        this.$store
            .dispatch(this.config.getVuexAlias("back.categorias.bases"), this.base)
            .then(res => {
                this.categorias_bases = res.data.data;
            });
    },
    methods: {
        categoria_cambiada() {
            this.items = [
                {
                    titulo: this.categorias_bases[this.base["categoria_base"]]["label"],
                    descripcion: null,
                    precio: this.categorias_bases[this.base["categoria_base"]]["precio"],
                },
            ];
        },
        terminar() {
            this.$emit("terminado");
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.terminar();
            }
        },
    },
    components: { Paises, Locations, Provincias },
};
</script>